/* eslint-disable react/no-unused-prop-types */

import React, { MouseEventHandler } from "react";
import { PulseLoader } from "react-spinners";

interface Props {
  title: string;
  btnStyle: string;
  disabled?: any;
  icon?: any;
  iconStyle?: string;
  textStyle: string;
  handleClick: MouseEventHandler<HTMLButtonElement>;
  image?: any;
  imageSize?: string;
  loading?: boolean;
  type?: "submit" | "button";
}
const ButtonV2 = ({
  title,
  disabled,
  btnStyle,
  icon,
  iconStyle,
  textStyle,
  handleClick,
  image,
  imageSize,
  loading,
  type,
}: Props) => (
  <button
    className={`${btnStyle} hover:scale-105 transition-all duration-300 ${
      disabled && "bg-opacity-75"
    }`}
    disabled={disabled}
    onClick={handleClick}
    type={type}
  >
    {loading ? (
      <PulseLoader color="#ffffff" size={14} />
    ) : (
      <span className={textStyle}>{title}</span>
    )}

    {image ? (
      <img alt="" src={image} className={imageSize} />
    ) : (
      <span className={iconStyle}>{icon}</span>
    )}
  </button>
);

export default ButtonV2;
